import React, { useContext } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { ToastContainer } from 'react-toastify';
import { defaultTheme } from 'utils/theme';
import { AuthContext } from 'contexts/AuthContext';
import Providers from 'contexts';
import App from 'views';
import Error from 'views/Error';
import Login from 'views/Login';
import Loading from 'views/Loading';

import 'moment/locale/pt-br';
import 'react-toastify/dist/ReactToastify.css';

const redirectToMainDomain = () => {
  window.location.href = 'https://esolution.eprom.com.br';
};

const AppGuard = ({ isAuthenticated }) => {
  if (!isAuthenticated) {
    if (process.env.NODE_ENV === 'development')
      return <Navigate to="/" replace />;
    redirectToMainDomain();
    return null;
  }
  return <App />;
};

const LoginGuard = ({ isAuthenticated }) => {
  if (isAuthenticated) return <Navigate to="/app" replace />;

  if (process.env.NODE_ENV === 'development') return <Login />;
  redirectToMainDomain();
  return null;
};

const Router = () => {
  const { isRefreshing, isAuthenticated } = useContext(AuthContext);

  if (isRefreshing && !isAuthenticated) return <Loading />;

  return (
    <Routes>
      <Route
        path="/"
        element={<LoginGuard isAuthenticated={isAuthenticated} />}
      />
      <Route
        path="/app/*"
        element={<AppGuard isAuthenticated={isAuthenticated} />}
      />
      <Route path="*" element={<Error />} />
    </Routes>
  );
};

const Root = () => {
  return (
    <ThemeProvider theme={createTheme(defaultTheme)}>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <BrowserRouter>
          <Providers>
            <Router />
          </Providers>
        </BrowserRouter>
        <ToastContainer />
      </LocalizationProvider>
    </ThemeProvider>
  );
};

ReactDOM.createRoot(document.getElementById('root')).render(<Root />);
